/**
 * TanStack Query keys for the project-page domain.
 *
 * Tuple-shaped per the repo convention (see
 * `feature-analytical-variables/src/lib/api/queryKeys.ts`). Identity by
 * value, not by reference — `[...]` literals in two different callers
 * collide on the cache key, which is what we want.
 */

export const projectPageKeys = {
  all: ['projectPage'] as const,
  chats: () => [...projectPageKeys.all, 'chats'] as const,
  /** Cache key for the per-project chat list, partitioned by ownerFilter. */
  chatsForProject: (projectId: string, ownerFilter: 'me' | 'team' | 'all') =>
    [...projectPageKeys.chats(), projectId, ownerFilter] as const,
  artifacts: () => [...projectPageKeys.all, 'artifacts'] as const,
  /** Cache key for the project knowledge manifest. */
  artifactsForProject: (projectId: string) => [...projectPageKeys.artifacts(), projectId] as const,
  activity: () => [...projectPageKeys.all, 'activity'] as const,
  /** Cache key for the project activity feed. */
  activityForProject: (projectId: string) => [...projectPageKeys.activity(), projectId] as const,
  /** Cache key for OR-6455's one-shot internal read-only chat snapshot. */
  internalChatSnapshot: (chatId: string) =>
    [...projectPageKeys.all, 'internalChatSnapshot', chatId] as const,
};
